import { type Customer } from "@repo/api";
import { InlineMessage, calendarIcon } from "@repo/skapa";
import { t } from "@repo/translation";

interface Props {
  customer?: Customer;
  onCancel: () => void;
}

export const FollowUpBanner = ({ customer, onCancel }: Props) => {
  const customerName = customer
    ? [customer.firstName, customer.lastName].filter(Boolean).join(" ")
    : undefined;
  const customerInfo = [customerName, customer?.email]
    .filter(Boolean)
    .join(", ");

  return (
    <InlineMessage
      variant="informative"
      ssrIcon={calendarIcon}
      title={
        customerInfo
          ? t("prompt.booking_follow_up_appointment_for", {
              customer: customerInfo,
            })
          : t("prompt.booking_follow_up_appointment")
      }
      body={t("prompt.select_open_slot_to_continue")}
      dismissable
      labelCloseButton={t("action.cancel")}
      onDismissClick={onCancel}
    />
  );
};
